import { PaginationComponent } from './pagination/pagination.component';
import { SearchBarComponent } from './search-bar/search-bar.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HeaderComponent } from './header/header.component';
import { RouterModule } from '@angular/router';
import { HeaderSecureComponent } from './header-secure/header-secure.component';
import { LoadingComponent } from './loading/loading.component';
import { FooterBasicComponent } from './footer-basic/footer-basic.component';
import { PipesModule } from '../../pipes/pipes.module';
import { IConfig, NgxMaskModule } from 'ngx-mask';
import { NgSelectModule } from '@ng-select/ng-select';
import { DirectivesModule } from '../../directives/directives.module';
import { ConfirmationModalComponent } from './confirmation-modal/confirmation-modal.component';
import { ToastComponent } from './toast/toast/toast.component';
import { PendingChangesModalComponent } from './pending-changes-modal/pending-changes-modal.component';
import { InfoComponent } from './info/info.component';

import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { NgxGaugeModule } from 'ngx-gauge';
import { SharedBlackListResultComponent } from './shared-black-list-result/shared-black-list-result.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { DocumentModule } from '../document/document.module';
import { SharedBlackListFormComponent } from './shared-black-list/shared-black-list-form/shared-black-list-form.component';
import { SharedBlackListModalComponent } from './shared-black-list/shared-black-list-modal/shared-black-list-modal.component';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { ValidationModule } from '../validation/shared.module';
import { InfoModalComponent } from './info-modal/info-modal.component';
import { TooltipRequiredComponent } from './tooltip-required/tooltip-required.component';
import { BillingPermissionInfoModalComponent } from './billing-permission-info-modal/billing-permission-info-modal.component';
import { ClientDropdownComponent } from './client-dropdown/client-dropdown.component';
import { GenericModule } from '../generic/generic.module';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { MainSidebarComponent } from './main-sidebar/main-sidebar.component';
import { StepSidebarComponent } from './step-sidebar/step-sidebar.component';
import { LogoutModalComponent } from './logout-modal/logout-modal.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { ValidationsModule } from "src/app/validators/validations.module";
import { ContactModalComponent } from './contact-modal/contact-modal.component';

const maskConfig: Partial<IConfig> = {
  validation: false,
};

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    DirectivesModule,
    NgSelectModule,
    PipesModule,
    NgxGaugeModule,
    NgxMaskModule.forRoot(maskConfig),
    TooltipModule.forRoot(),
    BsDatepickerModule,
    BsDropdownModule.forRoot(),
    DocumentModule,
    TabsModule,
    CollapseModule.forRoot(),
    ValidationModule,
    ModalModule.forChild(),
    ValidationsModule
],
  declarations: [
    HeaderComponent,
    HeaderSecureComponent,
    FooterBasicComponent,
    LoadingComponent,
    ConfirmationModalComponent,
    ToastComponent,
    SearchBarComponent,
    PaginationComponent,
    PendingChangesModalComponent,
    InfoComponent,
    SharedBlackListResultComponent,
    SharedBlackListFormComponent,
    SharedBlackListModalComponent,
    InfoModalComponent,
    TooltipRequiredComponent,
    BillingPermissionInfoModalComponent,
    ClientDropdownComponent,
    MainSidebarComponent,
    StepSidebarComponent,
    LogoutModalComponent,
    ContactModalComponent
  ],
  exports: [
    HeaderComponent,
    HeaderSecureComponent,
    FooterBasicComponent,
    LoadingComponent,
    ConfirmationModalComponent,
    ToastComponent,
    SearchBarComponent,
    PaginationComponent,
    PendingChangesModalComponent,
    InfoComponent,
    SharedBlackListResultComponent,
    SharedBlackListFormComponent,
    SharedBlackListModalComponent,
    InfoModalComponent,
    TooltipRequiredComponent,
    BillingPermissionInfoModalComponent,
    ClientDropdownComponent,
    MainSidebarComponent,
    StepSidebarComponent,
    LogoutModalComponent,
    ContactModalComponent
  ],
})
export class SharedModule {}
